import { render, staticRenderFns } from "./OfficersNode.vue?vue&type=template&id=764dd2fe&"
import script from "./OfficersNode.vue?vue&type=script&lang=js&"
export * from "./OfficersNode.vue?vue&type=script&lang=js&"
import style0 from "./OfficersNode.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports